import { render, staticRenderFns } from "./AnexosWilliam.vue?vue&type=template&id=074feeb7&scoped=true&"
import script from "./AnexosWilliam.vue?vue&type=script&lang=js&"
export * from "./AnexosWilliam.vue?vue&type=script&lang=js&"
import style0 from "./AnexosWilliam.vue?vue&type=style&index=0&id=074feeb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074feeb7",
  null
  
)

export default component.exports